import type { IProduct } from 'src/packages/polaris/types';
import CondensedCard from './Card';

const CondensedProductCards = ({
  products,
  moduleLocation,
  className,
}: {
  products?: IProduct[];
  moduleLocation: string;
  className?: string;
}) => {
  if (!products?.length) {
    return null;
  }
  return (
    <div
      className={`bp-no-scrollbar bp-flex bp-w-full bp-flex-nowrap bp-gap-x-2 bp-overflow-x-scroll ${className}`}
    >
      {products.map((product, i) => (
        <CondensedCard
          key={product.affiliate_url}
          order={i}
          moduleLocation={moduleLocation}
          url={product.affiliate_url}
          imageUrl={product.image_url}
          header={product.name}
          source={product.source}
          isPrime={product.is_prime}
          bulletPoints={[
            {
              icon: 'star',
              label: (
                <>
                  {product.rating?.toFixed(1)} ({product.ratings_count?.toLocaleString()} ratings)
                  on <span className="bp-capitalize">{product.source}</span>
                </>
              ),
            },
            {
              icon: 'cost',
              label: `$${product.price}`,
            },
          ]}
        />
      ))}
    </div>
  );
};

export default CondensedProductCards;
